import React, { FC } from 'react';
import PropTypes from 'prop-types';

import { LoadingBlock } from '../LoadingBlock';

import './ContentCard.scss';

interface Props {
    loading?: boolean
}

const ContentCard: FC<Props> = ({ loading = false, children }) => ( 
    <div>
        <div className="card">
            <div className="card-body">
                {loading ? <LoadingBlock /> : children}
            </div>
        </div>
    </div>
);

ContentCard.propTypes = {
    loading: PropTypes.bool
};

export default ContentCard;